import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { User } from '@core/objects/user';
import { AvatarsService } from '@core/services/avatars/avatars.service';
import { OnlineUserService } from '../../../services/online-user/online-user.service';

@Component({
    selector: 'core-avatar-img',
    templateUrl: './avatar-img.component.html',
    styleUrls: ['./avatar-img.component.scss'],
})
export class AvatarImgComponent implements OnInit, OnDestroy, OnChanges {

    @Input() user: User = null;
    @Input() size: number;
    @Input() onlineIcon: boolean = true;
    @Input() email:string = null;

    public image: string = 'assets/fake_avatar.png';

    protected subscription: Subscription = null;


    constructor(protected avatarsSrv: AvatarsService, public http: HttpClient, public onlineSrv: OnlineUserService) { }

    ngOnInit() {
        if (this.user != null){
            this.subscribeAvatar();
        }

        if(this.email)
            this.newAvatarEmail();
    }

    ngOnChanges(changes: SimpleChanges) {
        // dec-2024 <diego@twonas.com> prevent double load of same user in oone single instance of avatar
        if(changes.user && !changes.user.isFirstChange() && changes.user.currentValue != null) {
            this.ngOnDestroy();
            this.subscribeAvatar();
        }
    }

    ngOnDestroy() {
        if(this.subscription !== null){
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }
    
    /**
     * <diego@twonas.com>
     * @deprecated dec-2024 marked as not used: this could be not called due to
     *  core-avatar-img component is nevet called with email input
     */
    newAvatarEmail(){
        if(this.email == null)
            return;
            
        const uri = "/web/avatar/" + this.email + "/" + this.size + "/base64";
        this.http.get(uri, { responseType: 'text' }).subscribe(
            (data: any) => {
                this.image = data;
            }
        );
    }


    subscribeAvatar() {
        if(this.user == null)
            return;

        console.log("subscribing avatar", this.user, this.size);
        this.subscription = this.avatarsSrv.getSubscriptor(this.user, this.size).subscribe((avatar: string) => {
            this.image = avatar;
        });

        this.avatarsSrv.load(this.user, this.size);
    }
}
